import { configureStore } from "@reduxjs/toolkit";
import statsReducer from "./stats";
import gisReducer from "./gisStore";

export default configureStore({
    reducer: {
        cropStats: statsReducer,
        gisStore: gisReducer
    }
});